module.exports = __webpack_public_path__ + "img/16ne.8c54c4ea.svg";